import './backends/local.registration.js';
import './backends/localstorage.registration.js';
import './backends/websocket_rpc.registration.js';
import './custom_elements.js';
import './options/static.registration.js';
import './options/media.registration.js';
import './options/bind.registration.js';
